import React from "react"
import styles from "./message.module.css"
import { MdClose, MdInfoOutline, MdOutlineWarningAmber } from "react-icons/md"

const icons = {
    danger: <MdOutlineWarningAmber />,
    warning: <MdOutlineWarningAmber />,
    info: <MdInfoOutline />,
}

const Message = ({ text = "", title, closeMessage, actionLabel, onAction, variant = "warning" }) => {
    const icon = icons[variant] || icons.warning

    return (
        <div className={`${styles.container} ${styles[variant] || styles.warning}`}>
            <div className={styles.icon}>
                {icon}
            </div>
            <div className={styles.content}>
                {title && <strong>{title}</strong>}
                <span>{text}</span>
            </div>
            {actionLabel && onAction &&
                <button className={styles.action} onClick={onAction} type="button">
                    {actionLabel}
                </button>
            }
            {closeMessage &&
                <button className={styles.close} onClick={closeMessage} title="Fechar aviso" type="button">
                    <MdClose />
                </button>
            }
        </div>
    )
}

export default Message
